module.exports = __webpack_public_path__ + "38b2daf00863c24dd26d2e3bed0f89a5.png";